import { createContext } from "react";
const AdminBannerProvider = createContext();
export default AdminBannerProvider;
